import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import './WhereToBuy.css'
import ParallaxBasic from '../../components/page/parallaxBasic/ParallaxBasic.jsx'
import HeroImage from './hero-where-to-buy.jpg'
import InlineList from '../../components/global/inlineList/InlineList.jsx'
import GridBlocksData from './GridBlocksData.js'
import InlineListData from './InlineListData.js'
import Footer from '../../components/global/footer/Footer.jsx'

// let Scroller = Scroll.scroller;

/**
 * @class WhereToBuy
 * @namespace Architect\React\Views
 * @author Mike Rudling <mrudling@wearearchitect.com>
 */
export default class WhereToBuy extends Component {
  /**
   * Default props
   *
   * @type {{scrollOptions: {duration: number, delay: number, smooth: boolean}, ctaText: string, gridBlocksData: *[]}}
   */
  static defaultProps = {
    heroImage: HeroImage,
    parallaxTitle: 'Find the Fruit Bar',
    parallaxSubTitle: 'Solero® fruit bars and pops are available at various retailers nationwide. Find one near you!',
    ctaText: 'Have a Question?',
    ctaButtonText: 'contact us',
    scrollOptions: {
      duration: 1500,
      delay: 100,
      smooth: true
    },
    gridBlocksData: GridBlocksData,
    inlineListData: InlineListData,
    parallaxBasicClassNames: classNames('ParallaxBasic', 'Parallax__group', 'ParallaxBasic--short'),
    gridBlocksClassNames: classNames('GridBlocks', 'GridBlocks--short'),
    inlineListClassNames: classNames('InlineList', 'InlineList__logos')
  }

  /**
   * Prop types
   *
   * @type {{ parallaxTitle, parallaxSubTitle, ctaText: shim, gridBlocksData, inlineListData, scrollOptions: shim, ParallaxBasicClassNames: shim}}
   */
  static propTypes = {
    heroImage: PropTypes.string,
    parallaxBasicClassNames: PropTypes.string,
    gridBlocksData: PropTypes.arrayOf(PropTypes.object),
    scrollOptions: PropTypes.object,
    gridBlocksClassNames: PropTypes.string,
    inlineListClassNames: PropTypes.string,
    inlineListData: PropTypes.arrayOf(PropTypes.object),
    ctaText: PropTypes.string
  }

  /**
   * State
   *
   * @type {{contentLoaded: boolean}}
   */
  state = {
    contentLoaded: false,
    gridBlocksData: []
  }

  /**
   * Home Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props)

    this.getData = this.getData.bind(this)
    this.success = this.success.bind(this)
    this.error = this.error.bind(this)
  }

  /**
   * Component did mount
   */
  componentDidMount() {
    // const url = 'https://solero.com/wp-json/wp/v2/pages/116';

    // This is the url for the Where To Buy page in wordpress on sfclients.
    const url = 'https://solero-api.sfclients.com/wp-json/acf/v3/pages'
    this.getData(url)
  }

  /**
   * Get data from CMS.
   *
   * @param url
   */
  getData(url) {
    fetch(url)
      .then(res => res.json())
      .then(
        response => this.success(response),
        error => this.error(error)
      )
  }

  /**
   * Success response from Wordpress CMS Rest API.
   *
   * @param response
   */
  success(response) {
    let gridBlocksItems = response[0].acf.content_blocks[0].gridblocksitems

    let gridBlocksData = gridBlocksItems.map(item => {
      let header = false

      if (item.header === 'true: True') {
        header = true
      }

      let gridBlocksItem = {
        header: header,
        image: item.image.url,
        imageAlt: 'TO DO',
        text: item.text
      }

      return gridBlocksItem
    })

    this.setState({
      contentLoaded: true,
      gridBlocksData: gridBlocksData
    })
  }

  /**
   * Error fetch data from CMS.
   *
   * @param error
   */
  error(error) {
    this.setState({
      contentLoaded: false,
      error
    })
  }

  /**
   * Render
   *
   * @returns {XML}
   */
  render() {
    const {
      heroImage,
      parallaxTitle,
      parallaxSubTitle,
      parallaxBasicClassNames,
      inlineListData,
      inlineListClassNames,
      setHeaderClassNames
    } = this.props

    return (
      <main className="WhereToBuy Parallax">
        <ParallaxBasic
          background={heroImage}
          parallaxBasicClassNames={parallaxBasicClassNames}
          parallaxTitle={parallaxTitle}
          parallaxSubTitle={parallaxSubTitle}
          setHeaderClassNames={setHeaderClassNames}
        />

        <section>
          <InlineList data={inlineListData} inlineListClassNames={inlineListClassNames} />

          <p className="Center SmallPrint">
            Availability of Solero® bars may vary by retailer and store location. Please give your local retailer a call
            for availability of Solero® products and flavors.
          </p>
        </section>

        <Footer />
      </main>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/whereToBuy/WhereToBuy.jsx